import { defineMessages, useIntl } from 'react-intl'
import Box from 'components/shared/Box'
import Info from 'components/shared/Info'

interface UploadedPhotoErrorMessageProps {
    isPhotoFormatError: boolean
    isPhotoResolutionError: boolean
    isPhotoWeightError: boolean
}

const UploadedPhotoErrorMessage = ({
    isPhotoFormatError,
    isPhotoResolutionError,
    isPhotoWeightError,
}: UploadedPhotoErrorMessageProps) => {
    const { formatMessage } = useIntl()

    const messages = defineMessages({
        photoFormatError: {
            id: 'annual.uploader.photo_format_error',
            defaultMessage:
                'Wgrano zdjecię w niewspieranym formacie. Wgraj zdjęcie w formacie PNG, JPG lub JPEG.',
        },
        photoResolutionError: {
            id: 'annual.uploader.photo_too_small_error',
            defaultMessage:
                'Wgrane zdjęcie jest za małe. Minimalny rozmiar zdjęcia 492 x 633 piksele.',
        },
        photoWeightError: {
            id: 'annual.uploader.photo_too_big_error',
            defaultMessage:
                'Wgrane zdjęcie jest za duże. Maksymalny rozmiar zdjęcia to 5 MB.',
        },
    })

    return isPhotoFormatError ||
        isPhotoResolutionError ||
        isPhotoWeightError ? (
        <Box isFullWidth>
            <Box mt={[24, 40]} isFullWidth>
                <Info color="error">
                    {isPhotoFormatError &&
                        formatMessage(messages.photoFormatError)}
                    {isPhotoResolutionError &&
                        formatMessage(messages.photoResolutionError)}
                    {isPhotoWeightError &&
                        formatMessage(messages.photoWeightError)}
                </Info>
            </Box>
        </Box>
    ) : null
}

export default UploadedPhotoErrorMessage
